
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";

interface PermissionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const PermissionDialog: React.FC<PermissionDialogProps> = ({ 
  open, 
  onOpenChange, 
  onConfirm 
}) => {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("ballDistance.dialogs.permission.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            <div className="flex flex-col items-center justify-center space-y-4">
              <Lock className="h-16 w-16 text-muted-foreground" />
              <div className="text-center">
                <p>
                  {t("ballDistance.dialogs.permission.description1")}
                </p>
                <p className="mt-2">
                  {t("ballDistance.dialogs.permission.description2")}
                </p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("ballDistance.dialogs.permission.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t("ballDistance.dialogs.permission.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
